














































import Vue from "vue";

import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconMuscular from "@joyz/app-core/assets/icons/white/Muscular.svg";
import IconSkipped from "@joyz/app-core/assets/icons/misc/DrillSkip.svg";
import IconTypingDrill from "@joyz/app-core/assets/icons/black/DrillTyping.svg";
import TranslationDrillInput from "@tt-app/components/exercise/drill/TranslationDrillInput.vue";

interface Data {
  icons: { [key: string]: string };
}

interface Methods {
  onUserInput: (event: InputEvent) => void;
}

interface Computed {
  accuracy:
    | {
        icon: string;
      }
    | undefined
    | null;
  derivedAnswer: string;
  derivedDisabled: boolean;
  derivedLearnedStatus: {
    decrease: boolean;
    increase: boolean;
    learnedStatus: number;
  };
  derivedPlaceholder: string;
  derivedPrompt: string;
  drillIcon: string;
  evaluatedAnswer: any;
  reviewQuestion: any;
  wordCount: number;
}

interface Props {
  answer: string;
  answers: {
    [key: string]: {
      correctAnswer: {
        text: string;
      };
      text: string;
      isCorrect: boolean;
      learnedStatus: number;
      submittedAnswer: string;
    };
  };
  currentQuestionNumber: number;
  disabled: boolean;
  inReview: boolean;
  learnedStatus: number;
  practiceMode: boolean;
  prompt: string;
  questionAnswered: boolean;
  questionsByUuid: any;
  responseNumWords: number;
  totalQuestions: number;
  uuid: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "TranslationQuestion",

  components: {
    TranslationDrillInput
  },

  props: {
    answer: { type: String, default: "" },
    answers: { type: Object, default: () => ({}) },
    currentQuestionNumber: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
    inReview: { type: Boolean, default: false },
    learnedStatus: { type: Number, default: undefined },
    practiceMode: { type: Boolean, default: false },
    prompt: { type: String, default: "" },
    questionAnswered: { type: Boolean, default: false },
    questionsByUuid: { type: Object, default: () => ({}) },
    responseNumWords: { type: Number, default: 0 },
    totalQuestions: { type: Number, default: 0 },
    uuid: { type: String, default: "" }
  },

  data() {
    return {
      icons: {
        correct: IconCorrect,
        drill: IconTypingDrill,
        incorrect: IconIncorrect,
        muscular: IconMuscular,
        skipped: IconSkipped
      }
    };
  },

  methods: {
    onUserInput(event) {
      const target = event.target as HTMLInputElement;

      if (!target) {
        return;
      }

      this.$emit("answerUpdate", target.value);
    }
  },

  computed: {
    accuracy() {
      if (!this.evaluatedAnswer) {
        return null;
      }

      let icon = this.icons.skipped;

      if (this.evaluatedAnswer.isCorrect !== null) {
        icon = this.evaluatedAnswer.isCorrect ? this.icons.correct : this.icons.incorrect;
      }

      return {
        icon,
        correctAnswer: this.evaluatedAnswer.correctAnswer.text
      };
    },

    derivedAnswer() {
      if (this.inReview) {
        return this.evaluatedAnswer.submittedAnswer;
      }

      return this.answer;
    },

    derivedDisabled() {
      return this.disabled || this.questionAnswered;
    },

    derivedLearnedStatus() {
      const status = {
        decrease: false,
        increase: false,
        learnedStatus: this.learnedStatus
      };

      if (this.evaluatedAnswer) {
        status.learnedStatus = this.evaluatedAnswer.learnedStatus;

        const increase = this.evaluatedAnswer.learnedStatus > this.learnedStatus;
        const decrease = this.evaluatedAnswer.learnedStatus < this.learnedStatus;

        status.increase = increase;
        status.decrease = decrease;
      }

      if (this.inReview) {
        status.learnedStatus = this.evaluatedAnswer.learnedStatus;

        status.increase = this.evaluatedAnswer.learnedStatus > this.reviewQuestion.learnedStatus;
        status.decrease = this.evaluatedAnswer.learnedStatus < this.reviewQuestion.learnedStatus;
      }

      return status;
    },

    derivedPlaceholder() {
      return this.inReview ? "" : this.$__("drill.input-in-english");
    },

    derivedPrompt() {
      if (this.inReview) {
        return this.reviewQuestion.prompt;
      }

      return this.prompt;
    },

    drillIcon() {
      return this.practiceMode ? this.icons.muscular : this.icons.drill;
    },

    evaluatedAnswer() {
      return this.answers[this.uuid];
    },

    reviewQuestion() {
      return this.questionsByUuid[this.uuid];
    },

    wordCount() {
      let answer = this.answer;

      if (this.answers[this.uuid]) {
        answer = this.answers[this.uuid].submittedAnswer;
      }

      const responseNumWords = this.questionsByUuid[this.uuid].responseNumWords;

      const answerSplitWords = answer.split(" ").filter(Boolean);

      return responseNumWords - answerSplitWords.length;
    }
  }
});
